import { render, staticRenderFns } from "./PanelAddPerson.vue?vue&type=template&id=037c7a3c&scoped=true&"
import script from "./PanelAddPerson.vue?vue&type=script&lang=js&"
export * from "./PanelAddPerson.vue?vue&type=script&lang=js&"
import style0 from "./PanelAddPerson.vue?vue&type=style&index=0&id=037c7a3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037c7a3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('037c7a3c')) {
      api.createRecord('037c7a3c', component.options)
    } else {
      api.reload('037c7a3c', component.options)
    }
    module.hot.accept("./PanelAddPerson.vue?vue&type=template&id=037c7a3c&scoped=true&", function () {
      api.rerender('037c7a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelAddPerson.vue"
export default component.exports